/**
 * company-interface.js
 * 会社情報関連APIのI/F定義
 */

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

/**
 * 会社情報関連APIのI/F定義クラス
 */
export default class CompanyInterface {

  /**
   * コンストラクター
   */
  constructor () {
    // ペイロード要素
    this.PAYLOAD_ITEM = {
      // 処理種別
      EXECUTE_TYPE: 'execute-type',
      // データ
      DATA: 'data'
    }
    // 処理種別
    this.EXECUTE_TYPE = {
      // 会社一覧取得
      GET_COMPANY_LIST: 'get-company-list',
    }
    // ペイロード初期値
    this.payload = {
      // 処理種別
      [this.PAYLOAD_ITEM.EXECUTE_TYPE]: '',
      // データ
      [this.PAYLOAD_ITEM.DATA]: {}
    }
  }

  /**
   * 会社一覧取得クエリパラメーター作成
   */
  makeCompanyListGetParameter () {
    try {
      let queryParameter = ''
      // クエリパラメーターを作成
      queryParameter = '{0}={1}'.format(
        // 処理種別
        this.PAYLOAD_ITEM.EXECUTE_TYPE,
        // 会社一覧取得
        this.EXECUTE_TYPE.GET_COMPANY_LIST
      )

      // クエリパラメーターを返す
      return queryParameter
    } catch (error) {
      throw error
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/company/company-interface.js